import InternalCard from "./Card";

// export { CardGridProps } from './Grid';
// export { CardMetaProps } from './Meta';

var Card = InternalCard;

// Card.Grid = Grid;
// Card.Meta = Meta;

export default Card;